import { DOOH_REPORT_LOADER } from './config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case DOOH_REPORT_LOADER:
            return action.payload;
        
        default:
            return state;
    }
}

export default reducer;